export { default, type PartModalRef } from "./PartModal";
